import { render } from "./MMWebCategories.vue?vue&type=template&id=2c86fc98"
import script from "./MMWebCategories.vue?vue&type=script&lang=js"
export * from "./MMWebCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__